import {
  Avatar,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
import { AVATAR_COLORS, BORDER, STEP_COLORS, getInitials } from "./constants";

const COLUMNS = [
  { label: "CANDIDAT", field: "candidatNom" },
  { label: "MISSION", field: "missionName" },
  { label: "CLIENT", field: "societeName" },
  { label: "CONSULTANT", field: "consultantNom" },
  { label: "STEP", field: null },
];

const ResultsTable = ({ pageRows, startIdx, sortField, sortDir, onSort }) => (
  <TableContainer sx={{ flexGrow: 1, maxHeight: 680, overflowY: "auto" }}>
    <Table stickyHeader size="small">
      <TableHead>
        <TableRow>
          {COLUMNS.map(({ label, field }) => (
            <TableCell
              key={label}
              sortDirection={field && sortField === field ? sortDir : false}
              sx={{
                fontSize: 11,
                fontWeight: 500,
                color: "text.secondary",
                backgroundColor: "#f9fafb",
                borderBottom: BORDER,
                py: 1,
                whiteSpace: "nowrap",
                cursor: field ? "pointer" : "default",
                userSelect: "none",
              }}
            >
              {field ? (
                <TableSortLabel
                  active={sortField === field}
                  direction={sortField === field ? sortDir : "asc"}
                  onClick={() => onSort(field)}
                  sx={{
                    fontSize: 11,
                    fontWeight: 500,
                    color: "text.secondary",
                  }}
                >
                  {label}
                </TableSortLabel>
              ) : (
                label
              )}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {pageRows.length === 0 ? (
          <TableRow>
            <TableCell
              colSpan={5}
              align="center"
              sx={{
                py: 5,
                color: "text.secondary",
                fontSize: 13,
                border: "none",
              }}
            >
              Aucune donnée disponible.
            </TableCell>
          </TableRow>
        ) : (
          pageRows.map((row, idx) => {
            const fullName =
              `${row.candidatNom || ""} ${row.candidatPrenom || ""}`.trim() ||
              "-";
            const initials = getInitials(row.candidatNom, row.candidatPrenom);
            const avatarColor =
              AVATAR_COLORS[(startIdx + idx) % AVATAR_COLORS.length];

            return (
              <TableRow
                key={row.candidatId ?? idx}
                sx={{
                  "&:hover": { backgroundColor: "rgba(0,0,0,0.025)" },
                }}
              >
                <TableCell sx={{ py: 0.75, borderBottom: BORDER }}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <Avatar
                      sx={{
                        width: 26,
                        height: 26,
                        fontSize: 10,
                        fontWeight: 500,
                        backgroundColor: avatarColor,
                        flexShrink: 0,
                      }}
                    >
                      {initials}
                    </Avatar>
                    <Typography
                      sx={{
                        fontSize: 13,
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        maxWidth: 160,
                      }}
                    >
                      {row.candidatId ? (
                        <Link
                          to={{
                            pathname: `/candidats/${row.candidatId}/view`,
                          }}
                          style={{
                            color: "inherit",
                            textDecoration: "none",
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.textDecoration =
                              "underline")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.textDecoration = "none")
                          }
                        >
                          {fullName}
                        </Link>
                      ) : (
                        fullName
                      )}
                    </Typography>
                  </Box>
                </TableCell>

                <TableCell
                  sx={{
                    py: 0.75,
                    borderBottom: BORDER,
                    fontSize: 13,
                    maxWidth: 180,
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  {row.missionName ?? "-"}
                </TableCell>

                <TableCell
                  sx={{
                    py: 0.75,
                    borderBottom: BORDER,
                    fontSize: 13,
                    maxWidth: 150,
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  {row.societeName ?? "-"}
                </TableCell>

                <TableCell
                  sx={{
                    py: 0.75,
                    borderBottom: BORDER,
                    fontSize: 13,
                    maxWidth: 130,
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  {row.consultantNom ?? "-"}
                </TableCell>

                <TableCell sx={{ py: 0.75, borderBottom: BORDER }}>
                  {(() => {
                    const s = STEP_COLORS[row.step] ?? {
                      bg: "#f5f5f5",
                      color: "#616161",
                    };
                    return (
                      <Box
                        component="span"
                        sx={{
                          display: "inline-block",
                          px: 1,
                          py: "2px",
                          borderRadius: "8px",
                          fontSize: 11,
                          fontWeight: 500,
                          backgroundColor: s.bg,
                          color: s.color,
                          whiteSpace: "nowrap",
                        }}
                      >
                        {row.step ?? "-"}
                      </Box>
                    );
                  })()}
                </TableCell>
              </TableRow>
            );
          })
        )}
      </TableBody>
    </Table>
  </TableContainer>
);

export default ResultsTable;
